// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_0bb4673"};